import { Element } from 'react-scroll';
import AirportShuttleOutlinedIcon from '@mui/icons-material/AirportShuttleOutlined';
import ConnectingAirportsOutlinedIcon from '@mui/icons-material/ConnectingAirportsOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import LandscapeOutlinedIcon from '@mui/icons-material/LandscapeOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import { useTranslation } from 'react-i18next';

const AboutUs = ({ id }) => {
  const { t } = useTranslation();

  const services = [
    { label: t('about_us_flughafen'), Icon: ConnectingAirportsOutlinedIcon },
    { label: 'VIP Shuttle', Icon: StarBorderOutlinedIcon },
    { label: t('about_us_trip'), Icon: LandscapeOutlinedIcon },
    { label: t('about_us_point'), Icon: TimelineOutlinedIcon },
    { label: t('about_us_special'), Icon: AirportShuttleOutlinedIcon },
  ];

  return (
    <Element name={id}>
      <section className="aboutSection" aria-labelledby="about-title">
        <div className="aboutCard">
          <header className="aboutHeader">
            <p className="aboutEyebrow">{t('about_us_header')}</p>
            <span className="aboutSince">{t('about_us_since')}</span>
          </header>

          <div className="aboutIntroduction">
            <h2 id="about-title">{t('about_us_lefttext')}</h2>
            <div className="aboutStory">
              <p>{t('about_us_righttext')}</p>
            </div>
          </div>

          <div className="aboutServices">
            <div className="aboutServicesHeading">
              <p>{t('about_us_services')}</p>
              <span>{t('about_us_servicesText')}</span>
            </div>
            <ul>
              {services.map(({ label, Icon }) => (
                <li key={label}>
                  <span className="aboutServiceIcon" aria-hidden="true"><Icon /></span>
                  <span>{label}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </Element>
  );
};

export default AboutUs;
